import { useDispatch } from 'react-redux';
import Button from '../../../../components/Button';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import { appSlice } from '../../../../store/slices';
import { createRootModal } from '../../RootModal';

import './BillingInfoModal.scss';

const { productName, creditCurrency } = AppConfig;

const BillingInfoModal = createRootModal(({ handleClose }) => {
	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(appSlice.actions.closeLastModal());
	};

	return (
		<div className='BillingCurrencyInfo'>
			<div className='BillingCurrencyInfo__subHeader'>
				<h2 className='BillingCurrencyInfo__subHeader_title'>
					{t('How to use {currency}', { currency: creditCurrency })}
				</h2>
				<p className='BillingCurrencyInfo__subHeader_subtitle'>
					{t(
						'{currency} are internal units for use only within {productName}. They cannot be withdrawn or converted. Value: 1 {currency} = 1 USD.',
						{
							currency: creditCurrency,
							productName: productName,
						}
					)}
				</p>
			</div>

			<div className='BillingCurrencyInfo__content'>
				<div className='BillingCurrencyInfo__body'>
					{/* 1 */}
					<div className='BillingCurrencyInfo__body__item'>
						<div className='BillingCurrencyInfo__body__item_icon'>
							<Icon type={Icons.BLUE_FUEL_PUMP} width={40} height={40} />
						</div>

						<div>
							<h3 className='BillingCurrencyInfo__body__item_title'>{t('Pay fees')}</h3>
							<p className='BillingCurrencyInfo__body__item_subTitle'>
								{t('Cover network fees for outgoing transactions using {currency}.', {
									currency: AppConfig.creditCurrency,
								})}
							</p>
						</div>
					</div>
					{/* 2 */}
					<div className='BillingCurrencyInfo__body__item'>
						<div className='BillingCurrencyInfo__body__item_icon'>
							<Icon type={Icons.AML_CHECK} width={40} height={40} />
						</div>
						<div>
							<h3 className='BillingCurrencyInfo__body__item_title'>{t('Pay for AML checks')}</h3>
							<p className='BillingCurrencyInfo__body__item_subTitle'>
								{t(
									'AML checks reveal the origin of funds and protect you from asset blocking or freezing. Run a check now -  peace of mind is priceless!'
								)}
							</p>
						</div>
					</div>
					{/* 3 */}
					<div className='BillingCurrencyInfo__body__item'>
						<div className='BillingCurrencyInfo__body__item_icon'>
							<Icon type={Icons.LIGHT} width={40} height={40} />
						</div>
						<div>
							<h3 className='BillingCurrencyInfo__body__item_title'>{t('Coming soon')}</h3>
							<p className='BillingCurrencyInfo__body__item_subTitle'>
								{t("Stay tuned for updates and don't miss new features as they roll out")}
							</p>
						</div>
					</div>

					<Button className='BillingCurrencyInfo__body__button' styleType='secondary' onClick={closeModal}>
						{t('Done')}
					</Button>
				</div>
			</div>
		</div>
	);
});

export default BillingInfoModal;
